import { findConstellation } from './state';
import type { PlayState, RemoveCode } from './types';

export interface RemoveOutcome {
  code: RemoveCode;
  state: PlayState;
}

/** Delete a constellation: its lines go, its stars unlock, what only its lines blocked is freed, and a planet it surrounded is free again (its alignment stays chosen, out of force). Allowed in every mode (docs/02-Game-Design/Core Mechanics.md). */
export function removeConstellation(state: PlayState, word: string): RemoveOutcome {
  const at = findConstellation(state, word);
  if (at < 0) return { code: 'remove_refused', state };
  const constellations = state.constellations.filter((_, i) => i !== at);
  return { code: 'removed', state: { ...state, constellations, removals: state.removals + 1 } };
}
